// custom-main-collection-product-grid.js

const wrappers = document.querySelectorAll(".searchspring-wrapper");
const {
  formatPrice,
  generateProductCard,
  renderPagination,
  loadProducts,
  setupSorting,
  setupInfiniteScroll,
  setupFiltering,
} = utils;

wrappers.forEach((wrapper) => {
  const sectionId = wrapper.dataset.sectionId;
  const collectionId = wrapper.dataset.collectionId;
  const productsPerPage = parseInt(wrapper.dataset.productsPerPage) || 24;
  const paginationType = wrapper.dataset.paginationType;
  const sortSelector = wrapper.querySelector(".sort-by-dropdown");
  const collectionHandle = wrapper.dataset.collectionHandle === "all" ? "" : wrapper.dataset.collectionHandle;
  const searchTerms = wrapper.dataset.searchTerms || "";

  window.utils.currentWrapperData[sectionId] = wrapper.dataset;


  const searchQuery = searchTerms && `q=${encodeURIComponent(searchTerms)}&`;

  const totalCountElement = wrapper.querySelector(".total_products_count");

  // Filter elements
  const filtersContainer = document.getElementById(
    `filters-container-${sectionId}`
  );
  const activeFiltersContainer = document.getElementById(
    `active-filters-${sectionId}`
  );
  const clearAllBtn = document.getElementById(`clear-all-filters-${sectionId}`);
  const filterToggleBtn = document.getElementById(`filter-toggle-${sectionId}`);

  // Elements
  const productGrid = document.getElementById(
    `searchspring-product-grid-${sectionId}`
  );
  const paginationContainer = document.getElementById(
    `searchspring-pagination-${sectionId}`
  );
  const loadingOverlay = wrapper.querySelector(".loading-overlay");
  const infiniteScrollingLoading = document.querySelector(
    ".infinite-scroll-loading"
  );

  // Configuration
  const siteId = "ccwfx6";
  let baseUrl = `https://${siteId}.a.searchspring.io/api/search/search?${searchQuery}siteId=${siteId}&resultsFormat=native&filter.ss_available=1&bgfilter.collection_handle=${collectionHandle?.toLowerCase()}`;

  // ── Pull any filter/sort state from the URL so the first API call matches UI ──
  const urlStateActiveFilters = window.utils.getFiltersFromUrl(); // sets window.utils.filterParams & sortParam
  const initialFilterParams = window.utils.filterParams || "";
  const initialSortParam = window.utils.sortParam || "";
  const initialBaseUrl = `${baseUrl}${initialFilterParams}${initialSortParam ? `&${initialSortParam}` : ""}`;

  // Show/hide loading
  const showLoading = () => (loadingOverlay.style.display = "block");
  const hideLoading = () => (loadingOverlay.style.display = "none");

  // Initial load based on pagination type
  const urlParams = new URLSearchParams(window.location.search);
  const initialPage = parseInt(urlParams.get("page")) || 1;

  // Initialize filtering if filters container exists
  if (filtersContainer) {
    setupFiltering({
      sectionId,
      filtersContainer,
      activeFiltersContainer,
      clearAllBtn,
      filterToggleBtn,
      baseUrl: initialBaseUrl,
      siteId,
      collectionHandle,
      productGrid,
      paginationContainer,
      productsPerPage,
      showLoading,
      hideLoading,
      loadProducts,
      totalCountElement,
      paginationType,
      setupInfiniteScroll,
      loadingOverlay,
      infiniteScrollingLoading,
    });
  }

  // Initialize sorting
  setupSorting({
    sortSelector,
    baseUrl: initialBaseUrl,
    siteId,
    collectionId,
    collectionHandle,
    paginationType,
    productGrid,
    paginationContainer,
    productsPerPage,
    showLoading,
    hideLoading,
    loadProducts,
    loadingOverlay,
    infiniteScrollingLoading,
    setupInfiniteScroll,
    totalCountElement,
    sectionId,
  });

  if (paginationType === "infinite_scroll") {
    setupInfiniteScroll({
      baseUrl: initialBaseUrl,
      productsPerPage,
      productGrid,
      loadingOverlay,
      infiniteScrollingLoading,
      loadProducts,
      totalCountElement,
      sortSelector,
      sectionId,
    });
  } else {
    loadProducts({
      page: initialPage,
      baseUrl: initialBaseUrl,
      productsPerPage,
      productGrid,
      paginationContainer,
      showLoading,
      hideLoading,
      callback: () => {},
      totalCountElement,
      collectionHandle,
      siteId,
      sectionId,
    });
  }

  const mobileDrawer = document.getElementById(
    `mobile-filter-drawer-${sectionId}`
  );
  const mobileFiltersContainer = document.getElementById(
    `mobile-filters-content-${sectionId}`
  );
  const mobileActiveFiltersContainer = document.getElementById(
    `mobile-active-filters-list-${sectionId}`
  );

  const mobileResetAllBtn = mobileDrawer
    ? mobileDrawer.querySelector(".mobile-reset-all")
    : null;
  const mobileApplyBtn = mobileDrawer
    ? mobileDrawer.querySelector(".bttn")
    : null;
  const mobileCloseBtn = mobileDrawer
    ? mobileDrawer.querySelector(".mobile-filter-close")
    : null;
  const mobileOverlay = mobileDrawer
    ? mobileDrawer.querySelector(".mobile-filter-overlay")
    : null;

  // Handle opening the mobile drawer via the existing filter toggle button
  if (filterToggleBtn && mobileDrawer) {
    filterToggleBtn.addEventListener("click", (e) => {
      // Only activate drawer on small screens
      if (window.innerWidth <= 768) {
        e.preventDefault();
        mobileDrawer.classList.add("active");
        filterToggleBtn.classList.add("active"); // rotate chevron up
      }
    });
  }

  // Helper to close the mobile drawer
  function closeMobileDrawer() {
    mobileDrawer?.classList.remove("active");
    filterToggleBtn?.classList.remove("active"); // rotate chevron down
  }

  // Close interactions
  [mobileCloseBtn, mobileOverlay, mobileApplyBtn].forEach((el) => {
    if (el) {
      el.addEventListener("click", () => {
        closeMobileDrawer();
      });
    }
  });

  // Initialize SearchSpring filtering inside the mobile drawer
  if (mobileFiltersContainer) {
    setupFiltering({
      sectionId,
      filtersContainer: mobileFiltersContainer,
      activeFiltersContainer: mobileActiveFiltersContainer,
      clearAllBtn: mobileResetAllBtn,
      filterToggleBtn: null, // Drawer open/close handled separately
      baseUrl,
      siteId,
      collectionHandle,
      productGrid,
      paginationContainer,
      productsPerPage,
      showLoading,
      hideLoading,
      loadProducts,
      totalCountElement,
      paginationType,
      setupInfiniteScroll,
      loadingOverlay,
      infiniteScrollingLoading,
    });
  }
});
